import { useQuery } from '@tanstack/react-query';

import { IGetWarehouseSkusDataParams } from '@app/models/interfaces';
import Api from '@app/services/api';

export const useGetWarehouseSkusQuery = ({ warehouse_uid, ...params }: IGetWarehouseSkusDataParams) => {
  return useQuery({
    queryKey: ['getWarehouseSkus', warehouse_uid, params],
    queryFn: () => Api.wms.getWarehouseSkus({ warehouse_uid, ...params }),
    enabled: !!warehouse_uid,
  });
};
